






























import { Vue, Component, Prop } from 'vue-property-decorator';
import EditorCell from '@/editor/editor-block-view/components/EditorCell.vue';
import { ICell, IMergeValues } from '@/editor/types';
import { EBlockWidth, EContext } from '@/editor/types/enums';
import { IRecipient } from '@signing-page/documents/types/recipient';
import { IUser } from '@/types/User';
import { IEditorRecipientInput } from '@lib-shared/types/editor-recipient-input';

@Component({
  components: {
    EditorCell,
  },
})
export default class EditorRow extends Vue {
  @Prop() cells: ICell[];
  @Prop({ default: () => EContext.Document }) context: EContext;
  @Prop() mergeValues: IMergeValues;
  @Prop() isPdfViewer: boolean;
  @Prop() focusedRequiredId?: string;
  @Prop() blockWidthClass: EBlockWidth;
  @Prop() containsCoverImage: boolean;
  @Prop() pageWidth: number;
  @Prop() isBlockToggled: boolean;
  @Prop() isSigningSite: boolean;
  @Prop() sender: IUser;
  @Prop() recipient: IRecipient;
  @Prop() recipientInput!: IEditorRecipientInput[];
}
